import { __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useTheme } from '../../hooks/useTheme.js';

var SkipLink = function (props) {
    var handleStyleProps = useTheme().handleStyleProps;
    var baseStyle = {
        visibility: ["hidden", "visible"],
        position: "absolute",
        top: 0,
        transform: "translateY(-100%)",
        transition: "transform 0.3s",
        ":focus": {
            transform: "translateY(0%)",
        },
    };
    var forwardProps = handleStyleProps(props, {
        baseStyle: baseStyle,
        themeKey: "link",
    });
    return jsx("a", __assign({}, forwardProps));
};

export { SkipLink };
//# sourceMappingURL=index.js.map
